import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { withBem } from "../hocs";
import LinkWithArrow from "./link-with-arrow";

const Hiring = ({ cn, className }) => (
  <div className={classnames(cn(), className)}>
    <img
      src={"./images/team/looking@2x.png"}
      title="We're hiring!"
      className={cn("photo")}
    />
    <div className={cn("name")}>Looking?</div>
    <p className={cn("description")}>
      King Street is always on the lookout for unique talent. If you think you’d
      fit in, drop us a line.
    </p>
    <div className={cn("inline-fields")}>
      <div className={cn("inline-field", ["role"])}>
        <span>Get in touch</span>
        <span>
          <LinkWithArrow
            href="mailto:letsmake@kingstreetapps.com"
            className={cn("linkedin-link")}
          >
            <span>letsmake@kingstreetapps.com</span>
          </LinkWithArrow>
        </span>
      </div>
    </div>
  </div>
);

Hiring.propTypes = {};

export default withBem("team-member")(Hiring);
